import { Skeleton, Typography } from "@mui/material";

type Props = {
    text?: string | null;
    loading?: boolean;
};

export const Title = (props: Props) => {
    const { text, loading = false } = props;

    if (loading) {
        return <Skeleton variant="text" sx={{ width: "100%" }} />;
    }

    if (!text) {
        return (
            <Typography variant="h5" fontWeight={600}>
                -
            </Typography>
        );
    }

    return (
        <Typography variant="h5" fontWeight={600}>
            {text}
        </Typography>
    );
};
